import { createFileRoute } from '@tanstack/react-router'
import { claimTypesEnum } from 'User/utils/claims'
import ContractSection from 'Work/components/Work/Sections/Contracts/ContractSection'

import { Guard } from '../../-guard'

export const Route = createFileRoute('/work/$workId/contracts')({
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_asset]}>
            <ContractSection />
        </Guard>
    ),
})
